export default "__VITE_ASSET__8a471df8__"